export default __webpack_public_path__ + "static/media/both_icon.626dac8b.svg";